import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Data associated to the payment instrument. You can use this information to display the vaulted payment method in your UI.`}</p>
    <p>{`As an example, for a vaulted card, you will receive:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`{
    "first6Digits": "411111",
    "last4Digits": "1111",
    "expirationMonth": "05",
    "expirationYear": "2030",
    "cardholderName": "Primer Test",
    "network": "VISA",
    "binData": {
        "network": "VISA",
        "issuerCountryCode": "US",
        "issuerName": "TEST BANK, N.A.",
        "regionalRestriction": "UNKNOWN",
        "accountNumberType": "UNKNOWN",
        "accountFundingType": "UNKNOWN",
        "prepaidReloadableIndicator": "NOT_APPLICABLE",
        "productUsageType": "UNKNOWN",
        "productCode": "UNKNOWN",
        "productName": "UNKNOWN"
    },
    "isNetworkTokenized": false
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      